<script>
    import {
        showModal
    } from '@app/store/modalStore.svelte.js';
    import {
        cliConfigState
    } from '@app/store/cliConfigStore.svelte.js';
    import * as m from '@app/paraglide/messages.js';
    
    /** @type {{currentState: any}} */
    let { currentState, toggleMenu } = $props();

    function handleToggleMenu() {
        toggleMenu("cli");
    }
    </script>
    
    {#if cliConfigState.filter(cliTool => {return cliTool.options[0].selected === "true"}).length > 0}
    <li class="nav-item dropdown {currentState ? 'show' : ''}" role="menuitem">
        <a onclick={handleToggleMenu} 
           class="dropdown-toggle nav-link" 
           href="#!/"
           id="cliMenuButton"
           aria-haspopup="true"
           aria-expanded={currentState}
           role="button"
           aria-label={m.cli_tools_menu()}>{m.cli_tools()}</a>
        <div class="dropdown-menu {currentState ? 'show' : ''}" 
             role="menu" 
             aria-labelledby="cliMenuButton">
            {#each cliConfigState as cliType}
            <a class="dropdown-item" 
               href="#!/"
               onclick={() => showModal(cliType.modalName)}
               id="cli{cliType.name.replace(/\s+/g, '')}"
               role="menuitem"
               aria-label={m.open_cli_tool({ name: cliType.name })}>{cliType.name}</a>
            {/each}
        </div>
    </li>
    {/if}
